import React from "react";
import styles from "./FullProfile.module.css";

export default function ProfileSummary({ data }) {
  return (
    <div className={styles.profileData}>
      <h4>Profile Summary</h4>
      <p>
        {data &&
          data.profileSummary &&
          data.profileSummary.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </p>
    </div>
  );
}
